var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "scrollup",
      staticStyle: { display: "inline" },
      on: { click: _vm.scrollUp },
    },
    [_vm._v("Наверх")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }